import * as types from './types';

const INITIAL_STATE = {
  editHistory: [],
};


export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SEARCH_EDIT_HISTORY: {
      return {
        ...state,
        editHistory: [...action.payload],
      };
    }
    default:
      return state;
  }
}
